import { staticComponentValueConverter } from '../StaticComponentValues';
import { Battery, CellularConnection, Wifi } from '../../../../../../../assets/svgs';
import { useSelector } from 'react-redux';
import { translate } from '../../../../../../../utils/language';

const appBarArrowWithoutTextPages = ['SignIn', 'SignUp'];
function AppBarBase({ item, AppBarComponent, activeThemePage }) {
  const isAppBarActive =
    AppBarComponent &&
    (activeThemePage?.id === 'Main' ||
      activeThemePage?.id === 'bottomBar' ||
      activeThemePage?.id === 'appBar' ||
      activeThemePage?.id === 'generalStyle') &&
    activeThemePage?.isReservedName;

  const branding = useSelector(state => state.themeSlice.branding);

  const settings = useSelector(state => state.themeSlice?.settings);
  const isWebView = settings?.isWebView;
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const searchBarPlaceholder = item?.data?.searchBarPlaceholder;

  const time = new Date();
  const hours = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
  const minutes = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();

  const customization = staticComponentValueConverter(item?.customization);

  const isAppBarVisible =
    (isAppBarActive && !isWebView) || (activeThemePage?.id !== 'Profile' && activeThemePage?.id !== 'FrontPage');

  const pageBackgroundColor =
    (isAppBarVisible ? customization?.backgroundColor : branding?.generalStyle?.primaryThemeColor) || '#ffffff';

  return (
    <>
      <div
        className="w-full flex flex-col align-center justify-center "
        style={{
          backgroundColor: isWebView ? 'white' : isAppBarVisible && customization?.backgroundColor,
          position: 'relative',
          borderBottomRightRadius: customization?.bottomRadius,
          borderBottomLeftRadius: customization?.bottomRadius,
          ...(isAppBarActive &&
            (AppBarComponent?.name === 'AppBar_3' || AppBarComponent?.name === 'AppBar_5') && {
              backgroundColor: 'transparent',
              position: 'absolute',
              top: 0,
              zIndex: 21110,
            }),
        }}
      >
        <div className="w-full    flex flex-col   px-[6%] justify-center" style={{ fontSize: staticValues[13] }}>
          <div
            className="h-[31.8936529784px] 2xl:h-[40px] flex flex-row w-full pt-[6%] items-start justify-between pb-[10%]"
            style={{ color: isAppBarVisible ? 'unset' : pageBackgroundColor === '#ffffff' ? 'black' : 'white' }}
          >
            <div>{`${hours}:${minutes}`}</div>
            <div
              className="bg-black rounded-full  flex flex-row w-[30%] items-center px-1 absolute left-[50%] translate-x-[-50%]"
              style={{ height: staticValues[20], top: staticValues[10] }}
            ></div>
            <div className="flex shrink-0 flex-row gap-[4%] justify-end items-end">
              <CellularConnection
                className={` w-[15.946px] 2xl:w-[20px]`}
                style={{ fill: pageBackgroundColor === '#ffffff' ? 'black' : 'white' }}
              ></CellularConnection>
              <Wifi
                className={` w-[15.946px] 2xl:w-[20px] `}
                style={{ fill: pageBackgroundColor === '#ffffff' ? 'black' : 'white' }}
              ></Wifi>
              <Battery
                className={` w-[15.946px] 2xl:w-[20px] `}
                style={{ fill: pageBackgroundColor === '#ffffff' ? 'black' : 'white' }}
              ></Battery>
            </div>
          </div>
          {isAppBarActive && !isWebView && (
            <AppBarComponent
              searchBarPlaceholder={searchBarPlaceholder}
              customization={customization}
            ></AppBarComponent>
          )}
        </div>
      </div>
      {activeThemePage?.id !== 'Profile' && activeThemePage?.id !== 'FrontPage' && (
        <div className="flex flex-row" style={{ backgroundColor: isAppBarVisible && customization?.backgroundColor }}>
          {!isAppBarActive && activeThemePage?.id !== 'ProductDetail' && (
            <div className="flex flex-row py-[15px] items-center" style={{ paddingLeft: staticValues[20] }}>
              <svg width="22px" height="22px" viewBox="0 0 0.6 0.6" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.36 0.48a0.03 0.03 0 0 1 -0.021 -0.009l-0.15 -0.15a0.03 0.03 0 0 1 0 -0.042l0.15 -0.15a0.03 0.03 0 1 1 0.042 0.042L0.252 0.3l0.129 0.129A0.03 0.03 0 0 1 0.36 0.48"
                  fill={customization?.textColor}
                />
              </svg>

              {!appBarArrowWithoutTextPages.includes(activeThemePage?.id) && (
                <div
                  className=" ml-[10px]"
                  style={{
                    fontSize: staticValues[13],
                    marginLeft: staticValues[8],
                    fontWeight: 500,
                    color: customization?.textColor,
                  }}
                >
                  {translate(activeThemePage?.name)}
                </div>
              )}
            </div>
          )}
          {activeThemePage?.id === 'ProductDetail' && (
            <div className="rotate-[180deg] text-[20px] w-[35px] h-[35px] justify-center flex flex-row p-1 items-center rounded-full bg-white absolute  top-[calc(100%+10px)] z-[21] left-[10px]">
              &#10132;
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default AppBarBase;
